import { findEmoji } from '../Emoji/emojiIndex';

export type EmojiCardContent = {
  emoji?: string;
  imageUrl?: string;
};

export function resolveEmojiCardContent({
  emoji,
  imageUrl,
}: EmojiCardContent): EmojiCardContent {
  if (imageUrl) {
    return { imageUrl };
  }

  if (!emoji) {
    return {};
  }

  const resolvedEmoji = findEmoji(emoji);

  if (resolvedEmoji?.native?.trim()) {
    return { emoji: resolvedEmoji.native };
  }

  if (resolvedEmoji?.imageUrl) {
    return { imageUrl: resolvedEmoji.imageUrl };
  }

  return { emoji };
}
